<template>
<div class="chapter">
<div class="inner_page">
<p class="image"><a id="file_026"><img alt="Image" src="images/f0015-01.jpg"/></a></p><a id="file_026">
<p class="caption">This rare color shot shows an FF-1 modified to carry dual controls and redesignated FF-2. The unique out- and downward-folding main gear system developed by Grumman can be clearly seen. This type of gear was a part of every Grumman fighter up through the creation of the F4F Wildcat. This aircraft flew with a Naval Reserve unit based in St. Louis. <em>U.S. Navy via Stan Piet</em></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// file_026.vue?adb32638